import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import {  observer } from "mobx-react";
import React from "react";
import { Peca } from "../../modelo/dominio/Peca";
import SituacaoMinutaStore from "../../store/SituacaoMinutaStore";
import ParametroStore from "../../store/ParametroStore";
import { action, observable, makeObservable } from "mobx";
import { DadosProcessoDto } from "../../modelo/dto/DadosProcessoDto";
import { EnumOrigemProcesso } from "../../modelo";
import ProcessoExpandidoStore from "../../store/ProcessoExpandidoStore";

interface IPropsSituacaoPeca {
    dadosProcesso?: DadosProcessoDto,
    peca: Peca,
    handleSituacaoPeca: (descricaoSituacao: string) => any;
}


class SituacaoPeca extends React.Component<IPropsSituacaoPeca> {
    descricaoSituacao = this.props.peca.descricaoPeticaoStatus;

    handleSituacaoPeca = (event) => {
        this.descricaoSituacao = event.target.value;;

        this.props.handleSituacaoPeca(this.descricaoSituacao);
    };

    constructor(props: IPropsSituacaoPeca) {
        super(props);

        makeObservable(this, {
            descricaoSituacao: observable,
            handleSituacaoPeca: action
        });
    }

    get isOrigemEsij() {
        if (ProcessoExpandidoStore?.dadosProcesso?.origem === EnumOrigemProcesso.LEGADO ||
            this.props.dadosProcesso?.origem === EnumOrigemProcesso.LEGADO) {
            return true;
        } else {
            return false;
        }
    }

    render() {
        return (
            <FormControl fullWidth>
                <InputLabel id="label-situacao-peca">Situação da peça</InputLabel>
                <Select
                    labelId='label-situacao-peticao'
                    label='Modifique a situação da petição'
                    id={'dropDownMenuSituacoes'}
                    value={this.descricaoSituacao}
                    onChange={this.handleSituacaoPeca}
                >
                    {ParametroStore.situacoesPeticao.filter(situacaoPeticao => {
                        if (this.isOrigemEsij && situacaoPeticao.codigo != null) {
                            return situacaoPeticao;
                        } else if (!this.isOrigemEsij && situacaoPeticao.codigo == null) {
                            return situacaoPeticao;
                        }
                    }).map((situacao, index) => {
                        return (
                            <MenuItem
                                value={situacao.descricao}
                                key={index}
                                style={{ fontWeight: 'bold' }}
                            >
                                {situacao.descricao}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        );
    }
}

export default observer(SituacaoPeca);